import * as R from 'ramda';
import React from 'react';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// ui
import { PlacesAutocomplete } from '../../../ui';
//////////////////////////////////////////////////

const getValue = (value, concatLocationFields) => {
  if (R.and(G.isObject(value), G.isTrue(concatLocationFields))) return G.concatLocationFields(value);

  if (G.isObject(value)) return R.pathOr('', [GC.FIELD_ADDRESS_1], value);

  return R.or(value, '');
};

const PlaceAutocomplete = (props) => {
  const {
    id,
    width,
    value,
    values,
    height,
    disabled,
    handlers,
    hasError,
    setValues,
    fieldType,
    placeholder,
    omitAddress1,
    setFieldValue,
    locationMapper,
    setFieldTouched,
    addressFieldName,
    additionalStyles,
    shouldHandleEnter,
    useMenuPortalTarget,
    concatLocationFields,
    useFormattedAddress = false,
    customSelectLocationFunction,
  } = props;

  const handleBlur = () => setFieldTouched(id, true);

  const handleChange = (fieldName, value) => {
    setFieldValue(id, value);

    const changeHandler = G.getPropFromObject('customHandleChange', handlers);

    if (G.isFunction(changeHandler)) {
      changeHandler({ value, fieldProps: props });
    }
  };

  const handleSelect = async (value, enter = false) => {
    const getCatchCallback = () => {
      const handleEnter = R.path(['handleEnter'], handlers);

      if (G.isAllTrue(enter, G.isFunction(handleEnter), shouldHandleEnter)) {
        return () => handleEnter(value, id);
      }

      return null;
    };

    const resultCallback = async () => {
      let result;

      const geocodeByPlace = R.prop('geocodeByPlace', handlers);

      if (G.isFunction(geocodeByPlace)) {
        result = await geocodeByPlace(value, 'forms -> Fieldset2 -> geocodeByPlace', getCatchCallback);
      } else {
        result = await G.geocodeByPlaceAddress(
          value,
          'forms -> Fieldset2',
          getCatchCallback(),
          { addressFieldName, useFormattedAddress },
        );
      }

      return result;
    };

    const result = await resultCallback();

    const data = {
      ...result,
      label: id,
      [GC.FIELD_LOAD_BOARD_ORIGIN_CITY]: G.getPropFromObject('city', result), // TODO: check why it is here
    };

    let newValues = G.ifElse(
      G.isTrue(omitAddress1),
      R.omit(GC.FIELD_ADDRESS_1, data),
      data,
    );

    if (G.isNotNil(locationMapper)) newValues = locationMapper(data);

    const setValuesHandler = () => setValues(R.mergeRight(R.or(values, {}), newValues), id);

    if (G.isFunction(customSelectLocationFunction)) {
      if (R.equals(fieldType, 'locationObject')) {
        const newValues = R.assoc(id, result, R.or(values, {}));

        setValues(newValues);

        return customSelectLocationFunction({
          newValues,
          fieldName: id,
          location: result,
        });
      }

      if (R.equals(fieldType, 'updateCallback')) {
        setValuesHandler();

        return customSelectLocationFunction(newValues);
      }

      return customSelectLocationFunction(newValues, id);
    }

    setValuesHandler();
  };

  const _value = getValue(value, concatLocationFields);

  return (
    <PlacesAutocomplete
      id={id}
      width={width}
      value={_value}
      height={height}
      hasError={hasError}
      disabled={disabled}
      handleBlur={handleBlur}
      placeholder={placeholder}
      handleSelect={handleSelect}
      setFieldValue={handleChange}
      additionalStyles={additionalStyles}
      useMenuPortalTarget={useMenuPortalTarget}
    />
  );
};

export default PlaceAutocomplete;
